import { useQuery } from "react-query"

import type { Article, PrismicDocWithSelectedData } from "~/api/prismic/types"
import { QueryCacheKeys } from "~/state/ReactQuery"
import type { CustomQueryHook } from "~/types/react-query"

import type { QueryApi } from "../client"
import { queryApi } from "../client"
import { DocumentType } from "../enums"
import { getField, my, Predicates } from "../utils"

const PAGE_SIZE = 3

type ArticlePreview = PrismicDocWithSelectedData<
  Article,
  "title" | "subtitle" | "banner_image" | "meta_description"
>

export type RelatedArticlesQueryArgs = {
  articleId: string
  categoryIds: string[]
}

export const getRelatedArticles: QueryApi<
  ArticlePreview,
  RelatedArticlesQueryArgs
> = ({ req, categoryIds, articleId, ...rest }) => {
  return queryApi({
    req,
    pageSize: PAGE_SIZE,
    ...rest,
    predicates: [
      Predicates.at("document.type", DocumentType.ARTICLE),
      Predicates.any(`${my.article("categories")}.category_link`, categoryIds),
      Predicates.not("document.id", articleId),
    ],
    fetch: [
      getField.article("title"),
      getField.article("subtitle"),
      getField.article("banner_image"),
      getField.article("meta_description"),
    ],
  })
}

export const useRelatedArticlesQuery: CustomQueryHook<
  RelatedArticlesQueryArgs,
  ArticlePreview[]
> = ({ articleId, categoryIds }) => {
  return useQuery([QueryCacheKeys.RELATED_ARTICLES, articleId], async () => {
    const res = await getRelatedArticles({
      articleId,
      categoryIds,
    })

    return res.results
  })
}
